import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import PortfolioHome from "./pages/PortfolioHome";
import JournalPost from "./pages/JournalPost";

function ThemeControl() {
  const [theme, setTheme] = useState(() => {
    try {
      return localStorage.getItem("portfolio-theme") || "system";
    } catch {
      return "system";
    }
  });
  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    try {
      localStorage.setItem("portfolio-theme", theme);
    } catch {
      /* Theme works without storage. */
    }
  }, [theme]);
  function toggleTheme() {
    const dark =
      theme === "dark" ||
      (theme === "system" &&
        window.matchMedia("(prefers-color-scheme: dark)").matches);
    setTheme(dark ? "light" : "dark");
  }
  return (
    <button
      className="theme-control"
      onClick={toggleTheme}
      aria-label="Switch color theme"
      title="Switch color theme"
    >
      <span aria-hidden="true">◐</span>
    </button>
  );
}

function ScrollToLocation() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      let id;
      try {
        id = decodeURIComponent(hash.slice(1));
      } catch {
        return;
      }
      requestAnimationFrame(() =>
        document.getElementById(id)?.scrollIntoView(),
      );
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}

export function AppRoutes() {
  return (
    <>
      <ScrollToLocation />
      <Routes>
        <Route path="/" element={<PortfolioHome />} />
        <Route path="/journal/:slug" element={<JournalPost />} />
        <Route
          path="*"
          element={
            <div className="not-found">
              <p>Page not found</p>
              <h1>Let’s get you back.</h1>
              <a className="button" href="/">
                Return to the homepage
              </a>
            </div>
          }
        />
      </Routes>
      <ThemeControl />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
